import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import { CoSignBillingDetails, CoSignDefaultUserObject, CoSignRequest, CptDetails } from "../interfaces/cosign-billing.interface";
import { CoSignDocumentDetails } from "../interfaces/cosign-documents.interface";
import { formatDate } from "@angular/common";

@Injectable({ providedIn: "root" })
export class CoSignerClient {
    endpoint = "co-sign";
    constructor(private httpClient: HttpClient) { }

    getCoSigners(facilityId: string | null, disciplineId: number,defaultUserObj:CoSignDefaultUserObject): Observable<any[]> {
        return this.httpClient.get<any[]>(
            `${environment.endpoint}/${this.endpoint}/get-cosigners`,
            {params:{
                facilityId:facilityId!,
                disciplineId:disciplineId,
                documentId:defaultUserObj?.documentId??0,
                patientId:defaultUserObj?.patientId??null,
                date:defaultUserObj?.date??new Date().toISOString()
            }}
        );
    }

    getCoSignersByFacility(facilityId: string | null): Observable<any[]> {
        return this.httpClient.get<any[]>(
            `${environment.endpoint}/${this.endpoint}/get-cosigners/facility/${facilityId}`
        );
    }

    getCoSignBillingDetails(facilityid: string, cosignerid: string): Observable<CoSignBillingDetails> {
        return this.httpClient.get<CoSignBillingDetails>(
            `${environment.endpoint}/${this.endpoint}/get-cosign-billing-details/${facilityid}/${cosignerid}`);
    }

    getCoSignDocumentDetails(facilityid: string, cosignerid: string): Observable<CoSignDocumentDetails> {
        return this.httpClient.get<CoSignDocumentDetails>(
            `${environment.endpoint}/${this.endpoint}/get-cosign-documents/${facilityid}/${cosignerid}`);
    }

    getCoSignBillingCPTdetails(disciplineid: number, patientid: string, date: Date, requestedbyid: string) {
        const formattedDate = formatDate(date, 'MM-dd-yyyy', 'en-US');
        return this.httpClient.get<CptDetails>(
            `${environment.endpoint}/${this.endpoint}/get-billing-cpt-details/${patientid}/${disciplineid}/${formattedDate}/${requestedbyid}`);
    }

    signBillingDetails(cosignBillingRequest: CoSignRequest) {
        return this.httpClient.put(
            `${environment.endpoint}/${this.endpoint}/cosign-billing-details`, cosignBillingRequest);
    }

    signDocumentDetails(cosignDocuementRequest: CoSignRequest) {
        return this.httpClient.put(
            `${environment.endpoint}/${this.endpoint}/cosign-document-details`, cosignDocuementRequest);
    }
}
